// @generated by protoc-gen-connect-es v1.7.0 with parameter "target=ts,import_extension=none"
// @generated from file mono/artifact/v1/artifact.proto (package mono.artifact.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
import { AbortUploadRequest, AbortUploadResponse, CancelProcessingJobRequest, CancelProcessingJobResponse, ClassifyArtifactRequest, ClassifyArtifactResponse, CompleteUploadRequest, CompleteUploadResponse, CreateInternalArtifactRequest, CreateInternalArtifactResponse, CreateUploadSessionRequest, CreateUploadSessionResponse, DeleteArtifactRequest, DeleteArtifactResponse, DeleteChatArtifactRequest, DeleteChatArtifactResponse, ExpandArchiveArtifactRequest, ExpandArchiveArtifactResponse, GenerateDownloadUrlRequest, GenerateDownloadUrlResponse, GetArtifactChunkRequest, GetArtifactChunkResponse, GetArtifactRequest, GetArtifactResponse, GetChatArtifactRequest, GetChatArtifactResponse, GetProcessingJobRequest, GetProcessingJobResponse, GetProjectArtifactsRequest, GetProjectArtifactsResponse, LinkArtifactToEntityRequest, LinkArtifactToEntityResponse, ListArtifactsRequest, ListArtifactsResponse, ListChatArtifactsRequest, ListChatArtifactsResponse, ListEntityArtifactsRequest, ListEntityArtifactsResponse, ListProcessingJobsRequest, ListProcessingJobsResponse, RetryProcessingRequest, RetryProcessingResponse, SaveChatArtifactRequest, SaveChatArtifactResponse, StartArtifactProcessingRequest, StartArtifactProcessingResponse, TagArtifactToOutlineRequest, TagArtifactToOutlineResponse, TagArtifactToProjectRequest, TagArtifactToProjectResponse, UnlinkArtifactFromEntityRequest, UnlinkArtifactFromEntityResponse } from "./artifact_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * ArtifactService is tesoro's user-facing API. It owns:
 *   - upload sessions (presigned PUT URLs to MinIO)
 *   - artifact metadata (lookups, listing, soft-delete)
 *   - download URL generation (presigned GET; legacy GridFS rows surface
 *     enough metadata that callers can fall through to the legacy handler)
 *   - chunk reads (sheet preview/chunk/manifest, processed-output reads)
 *   - processing-job orchestration (delegates to mono.etl.v1.EtlService)
 *   - artifact <-> project / outline associations
 *
 * Persistence lives in pangaea (mono.datagateway.v1.ArtifactGatewayService).
 * Blob storage lives in MinIO (with a `gridfs` legacy provider for migrated
 * rows). Job execution lives in reverie.
 *
 * @generated from service mono.artifact.v1.ArtifactService
 */ export const ArtifactService = {
    typeName: "mono.artifact.v1.ArtifactService",
    methods: {
        /**
     * ---------------------------------------------------------------------------
     * Upload lifecycle
     * ---------------------------------------------------------------------------
     *
     * @generated from rpc mono.artifact.v1.ArtifactService.CreateUploadSession
     */ createUploadSession: {
            name: "CreateUploadSession",
            I: CreateUploadSessionRequest,
            O: CreateUploadSessionResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.artifact.v1.ArtifactService.CompleteUpload
     */ completeUpload: {
            name: "CompleteUpload",
            I: CompleteUploadRequest,
            O: CompleteUploadResponse,
            kind: MethodKind.Unary
        },
        /**
     * ExpandArchiveArtifact turns an already-uploaded ZIP artifact into one
     * child artifact per member, inheriting tenant/owner/project/chat from the
     * archive row. Document processing cannot read archives (baltigo's
     * detectFormat has no .zip case — "unsupported format: unknown"), so the
     * raw archive is NEVER handed to processing; its children are. The archive
     * row itself is left exactly as uploaded (bytes preserved, status
     * unchanged) — this call only ever adds rows, never mutates it.
     *
     * Mirrors zou's expandZipArtifact (the equivalent for project-file
     * attachments) but lives here because tesoro owns the artifact plane, the
     * MinIO client, and processing kick-off.
     *
     * Retrying reuses child identities derived from the archive, member path
     * and contents, and reuses each child's durably claimed initial job.
     *
     * @generated from rpc mono.artifact.v1.ArtifactService.ExpandArchiveArtifact
     */ expandArchiveArtifact: {
            name: "ExpandArchiveArtifact",
            I: ExpandArchiveArtifactRequest,
            O: ExpandArchiveArtifactResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.artifact.v1.ArtifactService.AbortUpload
     */ abortUpload: {
            name: "AbortUpload",
            I: AbortUploadRequest,
            O: AbortUploadResponse,
            kind: MethodKind.Unary
        },
        /**
     * CreateInternalArtifact is the server-side counterpart to
     * CreateUploadSession + CompleteUpload. It accepts the bytes inline,
     * writes them to MinIO at an artifactstore-conforming key, persists
     * the artifact row in status=UPLOADED, and returns the Artifact.
     *
     * Use this from server contexts that need to seed bytes (e.g.,
     * shirohige's blank-template creation for new volume documents). The
     * browser flow still uses presigned PUT via CreateUploadSession.
     *
     * Auth: requires a gateway-authenticated principal (X-Tenant-ID
     * header). If the request's tenant_id disagrees with the principal,
     * the principal wins.
     *
     * @generated from rpc mono.artifact.v1.ArtifactService.CreateInternalArtifact
     */ createInternalArtifact: {
            name: "CreateInternalArtifact",
            I: CreateInternalArtifactRequest,
            O: CreateInternalArtifactResponse,
            kind: MethodKind.Unary
        },
        /**
     * ---------------------------------------------------------------------------
     * Artifact metadata + retrieval
     * ---------------------------------------------------------------------------
     *
     * @generated from rpc mono.artifact.v1.ArtifactService.GetArtifact
     */ getArtifact: {
            name: "GetArtifact",
            I: GetArtifactRequest,
            O: GetArtifactResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.artifact.v1.ArtifactService.ListArtifacts
     */ listArtifacts: {
            name: "ListArtifacts",
            I: ListArtifactsRequest,
            O: ListArtifactsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.artifact.v1.ArtifactService.DeleteArtifact
     */ deleteArtifact: {
            name: "DeleteArtifact",
            I: DeleteArtifactRequest,
            O: DeleteArtifactResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.artifact.v1.ArtifactService.GenerateDownloadUrl
     */ generateDownloadUrl: {
            name: "GenerateDownloadUrl",
            I: GenerateDownloadUrlRequest,
            O: GenerateDownloadUrlResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.artifact.v1.ArtifactService.GetArtifactChunk
     */ getArtifactChunk: {
            name: "GetArtifactChunk",
            I: GetArtifactChunkRequest,
            O: GetArtifactChunkResponse,
            kind: MethodKind.Unary
        },
        /**
     * ---------------------------------------------------------------------------
     * Processing jobs (delegated to reverie)
     * ---------------------------------------------------------------------------
     *
     * @generated from rpc mono.artifact.v1.ArtifactService.StartArtifactProcessing
     */ startArtifactProcessing: {
            name: "StartArtifactProcessing",
            I: StartArtifactProcessingRequest,
            O: StartArtifactProcessingResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.artifact.v1.ArtifactService.GetProcessingJob
     */ getProcessingJob: {
            name: "GetProcessingJob",
            I: GetProcessingJobRequest,
            O: GetProcessingJobResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.artifact.v1.ArtifactService.CancelProcessingJob
     */ cancelProcessingJob: {
            name: "CancelProcessingJob",
            I: CancelProcessingJobRequest,
            O: CancelProcessingJobResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.artifact.v1.ArtifactService.ListProcessingJobs
     */ listProcessingJobs: {
            name: "ListProcessingJobs",
            I: ListProcessingJobsRequest,
            O: ListProcessingJobsResponse,
            kind: MethodKind.Unary
        },
        /**
     * RetryProcessing re-enqueues a failed job's underlying artifact through
     * reverie. Returns a NEW ProcessingJob (with a new job_id) — the prior
     * failed row is preserved for audit. Caller swaps to the new job_id for
     * polling. Fails CodeFailedPrecondition if the existing job is not in a
     * terminal failure state, since retrying a running job would race with
     * the live worker.
     *
     * @generated from rpc mono.artifact.v1.ArtifactService.RetryProcessing
     */ retryProcessing: {
            name: "RetryProcessing",
            I: RetryProcessingRequest,
            O: RetryProcessingResponse,
            kind: MethodKind.Unary
        },
        /**
     * ---------------------------------------------------------------------------
     * Document associations
     * ---------------------------------------------------------------------------
     *
     * @generated from rpc mono.artifact.v1.ArtifactService.TagArtifactToProject
     */ tagArtifactToProject: {
            name: "TagArtifactToProject",
            I: TagArtifactToProjectRequest,
            O: TagArtifactToProjectResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.artifact.v1.ArtifactService.TagArtifactToOutline
     */ tagArtifactToOutline: {
            name: "TagArtifactToOutline",
            I: TagArtifactToOutlineRequest,
            O: TagArtifactToOutlineResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.artifact.v1.ArtifactService.GetProjectArtifacts
     */ getProjectArtifacts: {
            name: "GetProjectArtifacts",
            I: GetProjectArtifactsRequest,
            O: GetProjectArtifactsResponse,
            kind: MethodKind.Unary
        },
        /**
     * Polymorphic attach-to-any-entity: link/list/unlink an artifact against any
     * owning entity (capture RFI, interaction, workstream, capture project, ...),
     * plus user-driven classification.
     *
     * @generated from rpc mono.artifact.v1.ArtifactService.LinkArtifactToEntity
     */ linkArtifactToEntity: {
            name: "LinkArtifactToEntity",
            I: LinkArtifactToEntityRequest,
            O: LinkArtifactToEntityResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.artifact.v1.ArtifactService.UnlinkArtifactFromEntity
     */ unlinkArtifactFromEntity: {
            name: "UnlinkArtifactFromEntity",
            I: UnlinkArtifactFromEntityRequest,
            O: UnlinkArtifactFromEntityResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.artifact.v1.ArtifactService.ListEntityArtifacts
     */ listEntityArtifacts: {
            name: "ListEntityArtifacts",
            I: ListEntityArtifactsRequest,
            O: ListEntityArtifactsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.artifact.v1.ArtifactService.ClassifyArtifact
     */ classifyArtifact: {
            name: "ClassifyArtifact",
            I: ClassifyArtifactRequest,
            O: ClassifyArtifactResponse,
            kind: MethodKind.Unary
        },
        /**
     * ---------------------------------------------------------------------------
     * Chat artifacts — personal, user-owned, VERSIONED documents authored in chat.
     *
     * A different entity from Artifact above (which is an uploaded file blob).
     * Backed by artifacts.chat_artifacts in pangaea, content bytes in MinIO.
     * Replaces express-backend's GET /api/document/artifacts/list, GET /:id and
     * PATCH /:id, which 403'd every non-internal user (see plans/chat-artifacts-off-express.md).
     *
     * AUTHZ: Cerbos `chat_artifact` kind, ownership-based. owner_user_id is
     * stamped server-side from the stored row and is NEVER read from the request.
     * ---------------------------------------------------------------------------
     *
     * @generated from rpc mono.artifact.v1.ArtifactService.ListChatArtifacts
     */ listChatArtifacts: {
            name: "ListChatArtifacts",
            I: ListChatArtifactsRequest,
            O: ListChatArtifactsResponse,
            kind: MethodKind.Unary
        },
        /**
     * @generated from rpc mono.artifact.v1.ArtifactService.GetChatArtifact
     */ getChatArtifact: {
            name: "GetChatArtifact",
            I: GetChatArtifactRequest,
            O: GetChatArtifactResponse,
            kind: MethodKind.Unary
        },
        /**
     * SaveChatArtifact is CREATE-OR-APPEND, mirroring the semantics of the express
     * handler it replaces: saving an unknown document_id creates the document,
     * saving a known one appends a version. Modelling this as "update" only would
     * silently drop artifact creation — the AI's in-memory artifact becomes durable
     * ONLY via this call.
     *
     * @generated from rpc mono.artifact.v1.ArtifactService.SaveChatArtifact
     */ saveChatArtifact: {
            name: "SaveChatArtifact",
            I: SaveChatArtifactRequest,
            O: SaveChatArtifactResponse,
            kind: MethodKind.Unary
        },
        /**
     * DeleteChatArtifact soft-deletes the whole document (all versions). Gated by
     * the Cerbos `chat_artifact` delete action against the STORED owner — a member
     * can only delete their own. Content blobs are retained (soft delete is
     * recoverable); only the rows are tombstoned.
     *
     * @generated from rpc mono.artifact.v1.ArtifactService.DeleteChatArtifact
     */ deleteChatArtifact: {
            name: "DeleteChatArtifact",
            I: DeleteChatArtifactRequest,
            O: DeleteChatArtifactResponse,
            kind: MethodKind.Unary
        }
    }
};
